const AboutUser = () => {
    return (<h1>This is about user component: private information</h1>)
}

export default AboutUser;